import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/login'
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Check if user has a practice, unless they are on a practice selection/creation page
  // or accepting an invitation
  const isPracticeSelectionRoute = [
    '/signup/select-practice',
    '/signup/create-practice',
    '/pending-invitations',
    '/accept-invite'
  ].some(path => location.pathname.startsWith(path));

  if (isAuthenticated && !user?.practice_id && !isPracticeSelectionRoute) {
    return <Navigate to="/pending-invitations" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
